import LogoLight from './animated_light.webm';
import LogoLightStill from './still_light_320.svg';
import LogoDark from './animated_dark.webm';
import LogoDarkStill from './still_dark_320.svg';
import LogoLightIcon from './logo-icon.png';
import LogoIconBlank from './logo_icon_blank.svg';

export { LogoLight, LogoLightStill, LogoDark, LogoDarkStill, LogoLightIcon, LogoIconBlank };
